export default {"src":"/_next/static/media/Calendar1.91973f99.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};